
<template>
	<div v-if="item">
		<div v-if="item.templateOptions">
			<h3>{{optionsHeader}}</h3>
			<section class="section-body" >
				<table class="requirements-table">
					<thead>
						<tr>
							<td>Name</td>
							<td>Required</td>
							<td>Description</td>
							<td>Link</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="opt in item.templateOptions.uri" v-bind:key="opt.name">
							<td>{{ opt.displayName || opt.name }}</td>
							<td>{{ opt.required ? 'Required' : 'Optional' }}</td>
							<td>{{ opt.description }}</td>
							<td>
								<a v-if="opt.link" :href="opt.link.uri" target="_blank">{{opt.link.text || 'Link'}}</a>
								<p v-else>-</p>
							</td>
						</tr>
						<tr v-for="opt in item.templateOptions.headers" v-bind:key="'headers_' + opt.header + opt.name">
							<td>{{ opt.displayName || opt.name || opt.header }}</td>
							<td>{{ opt.required ? 'Required' : 'Optional' }}</td>
							<td>{{ opt.description }}</td>
							<td>
								<a v-if="opt.link" :href="opt.link.uri" target="_blank">{{opt.link.text || 'Link'}}</a>
								<p v-else>-</p>
							</td>
						</tr>
						<tr v-for="opt in item.templateOptions.qs" v-bind:key="'qs_' + opt.param + opt.name">
							<td>{{ opt.displayName || opt.name || opt.param }}</td>
							<td>{{ opt.required ? 'Required' : 'Optional' }}</td>
							<td>{{ opt.description }}</td>
							<td>
								<a v-if="opt.link" :href="opt.link.uri" target="_blank">{{opt.link.text || 'Link'}}</a>
								<p v-else>-</p>
							</td>
						</tr>
					</tbody>
				</table>
			</section>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'Details',
	props: {
		item: Object,
		optionsHeader:{ type: String, default: "Configuration Options"}
		},
	};


</script>

<style scoped>

	.section-body{
		background-color: #EDF0F3;
		overflow: hidden;
		padding:10px;
		border-radius:3px;
		/* border: 1px solid #e3e6ea; */
		background-color: #EDF0F3;
	}
	table {
		width: 100%;
		background-color: white;
		overflow:hidden;

	}
	tbody tr:last-of-type{
		border-bottom-right-radius: 4px;
	}
	th{
		white-space: nowrap;
	}
	th, td{
		padding: 10px;
		font-size:12px;
	}
	table tr:last-child td:first-child {
		border-bottom-left-radius: 5px 10px;
	}

	table tr:last-child td:last-child {
		border-bottom-right-radius: 10px;
	}

	thead tr{
		font-weight: 600;
		color: #777;
	}

		/* // Extra small devices (portrait phones, less than 576px) */
	@media (max-width: 575.98px) {
		.section-body{
			overflow: scroll;
		}
	}

	/* // Small devices (landscape phones, 576px and up) */
	@media (min-width: 576px) and (max-width: 767.98px) {
		.section-body{
			overflow: scroll;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Details.vue